import { render } from "./WidgetConfiguration.vue?vue&type=template&id=628ed559&scoped=true"
import script from "./WidgetConfiguration.vue?vue&type=script&lang=js"
export * from "./WidgetConfiguration.vue?vue&type=script&lang=js"

import "./WidgetConfiguration.vue?vue&type=style&index=0&id=628ed559&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628ed559"]])

export default __exports__